import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#ec248f',
      light: '#ff6eb5',
      dark: '#b91d70',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#424242',
      light: '#6d6d6d',
      dark: '#1b1b1b',
      contrastText: '#ffffff',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          background: 'linear-gradient(45deg, #ec248f 30%, #ff6eb5 90%)',
          boxShadow: '0 4px 10px rgba(236, 36, 143, 0.25)',
          '&:hover': {
            boxShadow: '0 6px 12px rgba(236, 36, 143, 0.35)',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: '#ec248f',
        },
      },
    },
  },
});

export default theme; 